import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./MemoryFileUpload.css";
import { useSelector } from "react-redux";

function MemoryFileUploadDialog({ isOpen, onClose ,uploadedFiles, setUploadedFiles,handleDelete,selectedFiles, setSelectedFiles}) {

  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);
  const dropRef = useRef(null);

  const allowedTypes = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-powerpoint", // .ppt
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // ✅ .pptx
  ];

  const {listGlobalMemDocDataLoading,listGlobalMemDocData} = useSelector((state=>state.listGlobalMemDocDataReducer))


  const handleCheckboxChange = (file) => {
    setSelectedFiles((prev) => {
      const alreadySelected = prev.some((f) => f._id === file._id);
      if (alreadySelected) {
        return prev.filter((f) => f._id !== file._id); // deselect
      } else if (prev.length < 2) {
        return [...prev, file]; // select
      } else {
        return prev; // ignore if already 2 selected
      }
    });
  };
  
  
  const handleFiles = (files) => {
    const newFiles = Array.from(files).filter(
      (file) =>
        allowedTypes.includes(file.type) &&
        uploadedFiles.length < 2 &&
        !uploadedFiles.find((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setUploadedFiles((prev) => [...prev, ...newFiles].slice(0, 2));
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer?.files) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleFileInputChange = (e) => {
    handleFiles(e.target.files);
  };



  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="mem-file-action-dialog-overlay">
      <div className="mem-file-action-dialog-content">
        <div className="mem-file-action-dialog-header">
          <h6>Attach Files</h6>
          <button className="mem-file-action-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div
          ref={dropRef}
          className={`mem-file-action-drop-zone ${dragOver ? "drag-over" : ""}`}
          onClick={() => {
            if (uploadedFiles.length < 2) fileInputRef.current.click();
          }}
          onDragOver={(e) => {
            e.preventDefault();
            setDragOver(true);
          }}
          onDragLeave={(e) => {
            e.preventDefault();
            setDragOver(false);
          }}
          onDrop={(e) => {
            e.preventDefault();
            setDragOver(false);
            handleDrop(e);
          }}
        >
          {uploadedFiles.length + selectedFiles?.length >= 2 ? (
            <span className="mem-file-action-disabled-text">
              Maximum 2 files Attached
            </span>
          ) : (
            <span>Drag & Drop files here or Click to Attach</span>
          )}
          <input
            type="file"
            multiple
            accept=".pdf,.docx,.ppt"
            ref={fileInputRef}
            className="mem-file-action-hidden-input"
            onChange={handleFileInputChange}
            disabled={uploadedFiles.length + selectedFiles?.length >= 2}
          />
        </div>

        <ul className="mem-file-action-file-list">
          {uploadedFiles.map((file) => (
            <li key={file.name}>
              {file.name}
              <button onClick={() => handleDelete(file.name)}>Delete</button>
            </li>
          ))}
        </ul>

      {  
        listGlobalMemDocData?.length>0 && <>
        <hr />
        <h6 className="select_existing">Select from existing files</h6>
        <ul className="mem-file-action-dummy">
          {listGlobalMemDocData.map((file) => {
            console.log("listGlobalMemDocData",file)
            const isChecked = selectedFiles.some((f) => f._id === file._id);
            const isDisabled = selectedFiles.length + uploadedFiles?.length >= 2 && !isChecked;

            return (
              <li key={file?._id} className="mem-file-action-dummy-item">
                <label
                  className={`mem-file-action-custom-checkbox ${
                    isDisabled ? "disabled" : ""
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    disabled={isDisabled}
                    onChange={() => handleCheckboxChange(file)}
                  />
                  <span className="mem-file-action-checkmark" />
                  <span className="mem-file-action-filename">{file?.filename}</span>
                </label>
              </li>
            );
          })}
        </ul>
        </>
        }
      </div>
    </div>,
    document.body
  );
}

export default MemoryFileUploadDialog;
